
import ru from "../assets/images/flags/ru.png"
import uzCyrl from "../assets/images/flags/uz_cyrl.png"
import uzLatn from "../assets/images/flags/uz_latn.png"

const languages = {
  ru: {
    label: "ru",
    i18n: "russian",
    flag: ru,
  },
	uzCyrl: {
    label: "uz_cyrl",
		i18n: "uzbek_cyrl",
    flag: uzCyrl,
  },
	uzLatn: {
    label: "uz_latn",
		i18n: "uzbek_latn",
    flag: uzLatn,
  },
}

export default languages
